<template>
  <section class="app-main">
    <router-view v-slot="{ Component }">
      <transition name="fade-transform">
        <component :is="Component" />
      </transition>
    </router-view>
  </section>
</template>

<script setup>

</script>

<style lang="scss" scoped>
*{
  margin: 0;
  padding: 0;
}
</style>